import { Injectable } from '@angular/core';
import { SealMockApiService } from '@shipsfocus/seal';
import { companyTypes as companyTypesData, departmentTypes as departmentTypesData, userRoles } from 'app/mock-api/database/company/data';
import cloneDeep from 'lodash-es/cloneDeep';

@Injectable({
  providedIn: 'root'
})
export class CompanyMockApi {
  private _companyTypes: { id: string; index: number; name: string; slug: string }[] = companyTypesData;
  private _departmentTypes: { id: string; index: number; name: string; slug: string }[] = departmentTypesData;
  private _userRoles: typeof userRoles = userRoles;

  constructor(private _sealMockApiService: SealMockApiService) {
    this.registerHandlers();
  }

  registerHandlers(): void {
    this._sealMockApiService.onGet('api/database/company/types').reply(() => {
      const companyTypes = cloneDeep(this._companyTypes);

      return [200, companyTypes];
    });

    this._sealMockApiService.onGet('api/database/department/types').reply(() => {
      const departmentTypes = cloneDeep(this._departmentTypes);

      return [200, departmentTypes];
    });

    this._sealMockApiService.onGet('api/database/user/roles').reply(() => {
      const userRoles = cloneDeep(this._userRoles);

      return [200, userRoles];
    });
  }
}
